import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getPracticeLocationTypes,
  addPracticeLocation,
  updatePracticeLocations,
  getLocationSuggestions,
} from "../../actions/userActions/practiceLocationAction";
import { getCities } from "../../actions/userActions/cityAction";
import { Redirect } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { CircularProgress, IconButton } from "@mui/material";
import HrComponent from "../reuse_components/HrComponent";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import SingleSelect from "../designSystem/SingleSelect";
import BodyLargeMedium from "../designSystem/BodyLargeMedium";
import practicelocationicon from "../../assets/images/practicelocationicon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import TextField from "../designSystem/TextField";
import { validateFields } from "../../utils/Validations";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import { Check, CircleAlert, Map, MapPin, X } from "lucide-react";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import SecondaryButton from "../subComponents/buttons/SecondaryButton";
import AddNewDrawer from "../addNew/AddNewDrawer";
import AddNewForm from "../addNew/AddNewForm";
import cityicon from "../../assets/images/cityIcon (2).svg";
import { t } from "../../locales/translate";
import LocationPickerModal from "../gMap/LocationPickerModal";
import {
  Autocomplete,
  useJsApiLoader,
  GoogleMap,
  MarkerF,
} from "@react-google-maps/api";
import { GOOGLE_MAP_API_KEY, GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_LOADER_ID } from "../../Constatns";
import MapPreview from "../gMap/MapPreview";

function AddPracticeLocations({ onClose, editData, onSave }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const initialValues = {
    name: "",
    type: "",
    displayAddress: "",
    address: "",
    city: "",
    latitude: null,
    longitude: null,
  };
  const [loading, setLoading] = useState(true); // Loading state
  const [saveLoading, setSaveLoading] = useState(false);
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem, setDrawerItem] = useState(null);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [cityFilters, setCityFilters] = useState({
    textSearch: "",
    countryId: "1",
  });
  const cityBody = {
    filter: cityFilters,
    pageNumber: -1,
    pageSize: 0,
  };
  const allCities = useSelector((state) => state.cities_reducer.cities);
  const locationSuggestions = useSelector(
    (state) => state.practiceLocations_reducer.locationSuggestions,
  );
  const practiceLocationType = useSelector(
    (state) => state.practiceLocations_reducer.practiceLocationTypes,
  );
  const { isLoaded } = useJsApiLoader({
    id: GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
  const autocompleteRef = useRef(null);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const defaultCenter = { lat: 31.5204, lng: 74.3587 };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          dispatch(getCities(cityBody)),
          dispatch(getPracticeLocationTypes(-1)),
        ]);

        if (editData) {
          setFormValues(editData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [editData]);

  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, "practicelocation");
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setSaveLoading(true);
    try {
      if (editData) {
        await dispatch(updatePracticeLocations(formValues));
      } else {
        await dispatch(addPracticeLocation(formValues));
      }
      setSaveLoading(false);
      await onSave(formValues);
    } catch (error) {
      console.error("Error saving practice location:", error);
      setSaveLoading(false);
    }
  };

  const handleAddNew = (itemName) => {
    setDrawerItem(itemName);
    setDrawerOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const handleGoBack = () => {
    history.goBack();
  };
  const getOptions = (type) => {
    if (type === "allCities") {
      if (
        allCities !== "isLoading" &&
        allCities.length !== 0 &&
        allCities?.result.length !== 0
      ) {
        return allCities.result
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((city) => ({
            value: city.id,
            label: city.name,
          }));
      }
      return [];
    }

    if (type === "practiceLocationType") {
      if (
        practiceLocationType !== "isLoading" &&
        practiceLocationType.length !== 0 &&
        practiceLocationType.result &&
        practiceLocationType.result.length !== 0
      ) {
        return practiceLocationType.result
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((locationType) => ({
            value: locationType.id,
            label: locationType.name,
          }));
      }
      return [];
    }

    return [];
  };
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleCityChange = (event) => {
    setFormValues({
      ...formValues,
      city: event.value,
    });
  };
  const handleTypeChange = (event) => {
    setFormValues({
      ...formValues,
      type: event.value,
    });
  };
  const handleLocationInputChange = (locationName) => {
    if (locationName.length >= 3) {
      dispatch(getLocationSuggestions(locationName));
    }
  };

  const handleMapLocationChosen = (locationData) => {
    setFormValues((prev) => ({
      ...prev,
      latitude: locationData.lat,
      longitude: locationData.lng,
      address: locationData.address || prev.address,
    }));

    setFormErrors({});
  };

  const handlePlaceChanged = () => {
    if (autocompleteRef.current !== null) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry && place.geometry.location) {
        setFormValues((prev) => ({
          ...prev,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
          address: place.formatted_address || place.name,
        }));
      }
    }
  };
  const renderLocationSuggestions = (locations) => {
    return locations.map((location, index) => (
      <div key={index} className="suggestion-item">
        <BodySmallMedium text={location.name} />
        {(location.address || location.typeName) && (
          <BodyExtraSmallMedium
            text={
              location.address && location.typeName
                ? `${location.address} • ${location.typeName}`
                : location.address || location.typeName
            }
          />
        )}
      </div>
    ));
  };
  return (
    <>
      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container overlay-wrapper">
          <LoadingOverlay isVisible={loading || saveLoading} />
          <div className={loading || saveLoading ? "blur" : ""}>
            <div className="dynamicmodal-header mb-3">
              <div className="dynamicmodal-header-left">
                <div className="icon">
                  <img src={practicelocationicon} alt="practicelocationicon" />
                </div>
                <div className="text">
                  <h2 className="modalheading">
                    {editData
                      ? "Edit Practice Location"
                      : `${t("addPracticeLocation")}`}
                  </h2>
                  <p className="modaldescription">
                    {t("addPracticeLocationTip")}
                  </p>
                </div>
              </div>
              <div className="dynamicmodal-header-right">
                <IconButton onClick={onClose}>
                  <img src={closeModal} alt="" />
                </IconButton>
              </div>
            </div>

            <form onSubmit={handleSave}>
              <div className="dynamicmodal-body">
                <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                  <div style={{ flex: 1 }}>
                    <div className="dynamicmodal-form-group">
                      <TextField
                        label={`${t("name")} *`}
                        type="text"
                        name="name"
                        value={formValues.name}
                        onChange={handletextChange}
                        placeholder={t("name")}
                        error={formErrors.name}
                        enableSuggestions={true}
                        suggestions={locationSuggestions || []}
                        minCharsForSuggestions={3}
                        onSuggestionInputChange={handleLocationInputChange}
                        renderSuggestions={renderLocationSuggestions}
                      />
                    </div>
                  </div>

                  <div style={{ flex: 1 }}>
                    <SingleSelect
                      label={`${t("locationType")} *`}
                      isSearchable
                      secondaryLabel
                      error={formErrors.type}
                      iconEnd
                      onChange={handleTypeChange}
                      value={formValues.type}
                      placeholder={t("locationType")}
                      options={
                        practiceLocationType &&
                        practiceLocationType !== "isLoading" &&
                        practiceLocationType.length !== 0 &&
                        practiceLocationType.result &&
                        practiceLocationType.result.length !== 0 &&
                        getOptions("practiceLocationType")
                      }
                    />
                  </div>
                </div>
                <SingleSelect
                  label={`${t("city")} *`}
                  isSearchable
                  secondaryLabel
                  error={formErrors.city}
                  iconEnd
                  onChange={handleCityChange}
                  value={formValues.city}
                  placeholder={t("city")}
                  options={
                    allCities &&
                    allCities !== "isLoading" &&
                    allCities.length !== 0 &&
                    allCities?.result &&
                    allCities.result?.length !== 0 &&
                    getOptions("allCities")
                  }
                  isLoading={!allCities || allCities === "isLoading"}
                  configKey={"city"}
                  onAddNewClick={() => handleAddNew("city")}
                />
                <div className="dynamicmodal-form-group">
                  <TextField
                    name="displayAddress"
                    label={t("displayAddress")}
                    type="text"
                    value={formValues.displayAddress}
                    onChange={handletextChange}
                    placeholder={t("enterDisplayAddress")}
                    error={formErrors.displayAddress}
                  />
                </div>
                <div className="dynamicmodal-form-group">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      gap: "12px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      {isLoaded ? (
                        <Autocomplete
                        onLoad={(autocomplete) => {
                          autocompleteRef.current = autocomplete;
                          autocomplete.setComponentRestrictions({ country: "pk" });

                          const pakistanBounds = new window.google.maps.LatLngBounds(
                            new window.google.maps.LatLng(23.6345, 60.872972),
                            new window.google.maps.LatLng(37.084107, 77.840927)
                          );
                          autocomplete.setBounds(pakistanBounds);
                        }}
                        onPlaceChanged={handlePlaceChanged}
                      >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <label
                              style={{ fontSize: "14px", marginBottom: "5px", textAlign: document.body.dir === "rtl" ? "right" : "left", color: "#1E293B", fontWeight: "400" }}
                            >{`${t("address")} *`}</label>
                            <input
                              name="address"
                              type="text"
                              value={formValues.address}
                              onChange={handletextChange}
                              placeholder={t("address")}
                              style={{
                                width: "100%",
                                height: "40px",
                                padding: "10px",
                                borderRadius: "60px",
                                border: formErrors.address
                                  ? "1px solid red"
                                  : "1px solid #ccc",
                              }}
                            />
                            {formErrors.address && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  color: "#C80000",
                                  fontSize: "12px",
                                  backgroundColor: "#FFE3E3",
                                }}
                              >
                                <CircleAlert height={16} />
                                <span>{formErrors.address}</span>
                              </div>
                            )}
                          </div>
                        </Autocomplete>
                      ) : (
                        <TextField
                          name="address"
                          label={`${t("address")} *`}
                          type="text"
                          value={formValues.address}
                          onChange={handletextChange}
                          placeholder="Loading Map features..."
                          error={formErrors.address}
                        />
                      )}
                    </div>

                    <div
                      className="practice-location-map-button"
                      style={{
                        paddingBottom: formErrors.address ? "18px" : "0",
                      }}
                    >
                      <SecondaryButton
                        onClick={(e) => {
                          e.preventDefault();
                          setMapModalOpen(true);
                        }}
                        text={t("map")}
                        icon={MapPin}
                        height="16px"
                        width="16px"
                        style={{
                          backgroundColor: "#D3D7FF",
                          borderColor: "#0438B4",
                          color: "#1E293B",
                          border: "1px solid #0438B4",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="practice-location-map-preview"
                    style={{
                      marginTop: "16px",
                      marginBottom: "16px",
                      borderRadius: "8px",
                      overflow: "hidden",
                      height: "150px",
                      border: "1px solid #ccc",
                    }}
                  >
                    <MapPreview
                      isLoaded={isLoaded}
                      lat={formValues.latitude || defaultCenter.lat}
                      lng={formValues.longitude || defaultCenter.lng}
                      loadingText={t("loadingMap")}
                      showMarker={!!formValues.latitude && !!formValues.longitude}
                    />
                  </div>
                </div>
              </div>
              <div className="dynamicmodal-footer">
                <CancelButton
                  onClick={onClose}
                  text={t("cancel")}
                  width={document.body.dir === "rtl" ? "119px" : ""}
                />
                <PrimaryButton
                  text={t("save")}
                  icon={Check}
                  width={document.body.dir === "rtl" ? "123px" : ""}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <AddNewDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        title={
          drawerItem ? t("addItem").replace(/{{item}}/g, t(drawerItem)) : ""
        }
        subtext={
          drawerItem
            ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem))
            : ""
        }
        icon={
          drawerItem === "city" ? <img src={cityicon} alt={drawerItem} /> : null
        }
        loading={drawerLoading}
      >
        {drawerItem && (
          <AddNewForm
            itemName={drawerItem}
            onClose={() => setDrawerOpen(false)}
            onLoadingChange={setDrawerLoading}
            onSave={(newCity) => {
              if (drawerItem === "city") {
                dispatch(getCities(cityBody)).then(() => {
                  setFormValues((prev) => ({
                    ...prev,
                    city: newCity.id,
                  }));
                });
              }
            }}
          />
        )}
      </AddNewDrawer>
      <LocationPickerModal
        isOpen={mapModalOpen}
        onClose={() => setMapModalOpen(false)}
        onChooseLocation={handleMapLocationChosen}
        initialLocation={{
          lat: formValues.latitude,
          lng: formValues.longitude,
        }}
         restrictToCountry="pk"
      />
    </>
  );
}

export default AddPracticeLocations;
